const getElement = el => {
  if (['TEXTAREA', 'INPUT'].includes(el.tagName)) {
    return el
  } else {
    return el.querySelector('input') || el.querySelector('textarea') || el.querySelector('select')
  }
}

export default {
  bind: (el, binding, vnode) => {
    const element = getElement(el)
    // if element is set and a value is passed, skip the focusing
    if (binding.value === undefined || binding.value) {
      vnode.context.$once('hook:mounted', () => {
        if (element) {
          element.focus()
        }
      })
    }
  },
}
